class Ajaxinate {
  constructor(config = {}) {
    // Merge defaults with passed config
    this.settings = {
      callback: config.callback || null,
      containerSelector: '[data-ajaxinate-container]',
      btnSelector: '[data-ajaxinate-load-more]',
      paginationCount: '#viewed-count'
    };

    this.container = document.querySelector(this.settings.containerSelector);
    this.loadMoreBtn = document.querySelector(this.settings.btnSelector);
    this.loading = false;

    if (!this.container || !this.loadMoreBtn) return;

    this.init();
  }

  init() {
    this.loadMoreBtn.addEventListener('click', (e) => {
      e.preventDefault();
      this.loadMore();
    });
  }

  async loadMore() {
    if (this.loading) return;
    
    const url = this.loadMoreBtn.getAttribute('href');
    if (!url) return;

    this.loading = true;
    this.loadMoreBtn.classList.add('loading');

    const loadMoreText = this.loadMoreBtn.textContent;

    this.loadMoreBtn.textContent = 'Loading...';

    try {
      const response = await fetch(url);
      const text = await response.text();
      const html = new DOMParser().parseFromString(text, 'text/html');

      // 1. Identify new items (Products or Blog Articles)
      const newItems = html.querySelectorAll(`${this.settings.containerSelector} .grid__item, ${this.settings.containerSelector} .blog-articles__article`);
      
      // 2. Append items to the current container
      newItems.forEach((item) => {
        this.container.appendChild(item);
      });

      const newPagination = html.querySelector('[data-ajaxinate-load-more]');

      // 3. Update Pagination UI
      const newPaginationCount = html.querySelector(this.settings.paginationCount);
      const oldPaginationCount = document.querySelector(this.settings.paginationCount);
      
      if (newPaginationCount && oldPaginationCount && newPagination) {
        oldPaginationCount.textContent = newPaginationCount.textContent;
        // Re-bind the button and reference because the old one was replaced in the DOM
        this.loadMoreBtn.setAttribute(
          'href',
          newPagination.getAttribute('href')
        );
        this.init();
      } else {
        oldPaginationCount.textContent = newPaginationCount.textContent;
        this.loadMoreBtn.remove();
      }

      // 4. TRIGGER THE CALLBACK
      if (typeof this.settings.callback === 'function') {
        this.settings.callback();
      }

    } catch (error) {
      console.error('Ajaxinate error:', error);
    } finally {
      if (this.loadMoreBtn) this.loadMoreBtn.classList.remove('loading');
      this.loading = false;
      if (this.loadMoreBtn) this.loadMoreBtn.textContent = loadMoreText;
    }
  }
}

// Initialization with the "Viewed Count" Logic
document.addEventListener('DOMContentLoaded', () => {
  new Ajaxinate({
    callback: () => {
      // Logic to update the "Viewed 72 of 126" text from your image
      const countElement = document.getElementById('viewed-count');
      // Count only actual product/result cards (exclude promo banners inserted into the grid).
      const loadedItems = document.querySelectorAll(
        '[data-ajaxinate-container] .grid__item:not(.promotion-banner-card):not([data-promo-tile])'
      ).length;
      
      if (countElement) {
        countElement.textContent = loadedItems;
      }
    }
  });
});